import { defineComponent } from "../../../common/runtime/defineComponent.svelte";

defineComponent({
  tag: "oc-tab-bar-v1",
  props: {
    showDivider: { type: "Boolean", attribute: "show-divider" },
    iconPosition: { type: "String", reflect: true, attribute: "icon-position" },
    selected: { type: "Number", reflect: false },
    variant: { type: "String" },
  },
  component: () => import("./TabBarV1.svelte"),
  styles: () => import("./TabBarV1.global.scss?inline"),
});
